import { render } from "./ContactSupportModal.vue?vue&type=template&id=55c4f7cf&ts=true"
import script from "./ContactSupportModal.vue?vue&type=script&lang=ts"
export * from "./ContactSupportModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__